// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import TitledCard from 'common/components/cards/TitledCard';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { ChromePicker } from 'react-color';
import { Label, ColorPickerContainer, MargedBlock } from '../../styles';
import type { StatsRadioPlayerData } from '../../../domain/PlayerConfiguration';
import RecentlyPlayedSongsDemo from './demos/RecentlyPlayedSongsDemo';

const InfoMessage = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.primary};
  margin: 0;
`;

type Props = {
  data: StatsRadioPlayerData;
  onThemeChange: (data: Object) => any;
  onValueChange: (key: string, value: any) => any;
  t: any;
  theme: Object;
}

type State = {
  backgroundColor: string;
  mainTextColor: string;
  secondaryText: string;
}

class RecentlyPlayed extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    const theme = props.data.theme.recentlyPlayedSongs;
    this.state = {
      backgroundColor: theme.backgroundColor,
      mainTextColor: theme.mainTextColor,
      secondaryText: theme.secondaryText,
    };
  }

  onRadioButtonChanged(state, value) {
    this.setState({ [state]: value });
  }

  onColorChange(key, value) {
    this.setState({ [key]: value.hex });
  }

  onColorChangeComplete(key, value) {
    const data = {
      ...this.props.data.theme.recentlyPlayedSongs,
      [key]: value.hex,
    };

    this.props.onThemeChange(data);
  }

  onMaxSongsChange(value) {
    const allowed = /^\d+$/;

    if (!allowed.test(value) && value !== '') {
      return;
    }

    this.props.onValueChange('maxSongs', value);
  }

  shouldDisplay() {
    return this.props.data.nowPlayingSong.display && this.props.data.recentlyPlayedSongs.display;
  }

  render() {
    const { data, t, theme } = this.props;

    return (
      <TitledCard title={t('songsRecentlyPlayed')}>
        <div className="row">
          <div className="col-xs-6">
            <InfoMessage style={{ color: theme.colors.primary }}>
              <i className="material-icons" style={{ paddingRight: theme.metrics.smallMargin }}>info</i>
              {t('contactUsForThisSection')}
            </InfoMessage>
            <Label withPadding>{t('doYouWantToDisplayCurrentPlayingSong')}</Label>
            <RadioButtonGroup
              name="doYouWantToDisplayCurrentPlayingSong"
              defaultSelected={data.nowPlayingSong.display}
              onChange={(e, v) => this.props.onValueChange('nowPlayingSong', v)}
            >
              <RadioButton
                value
                label={t('yes')}
              />
              <RadioButton
                value={false}
                label={t('no')}
              />
            </RadioButtonGroup>
            <div>
              { data.nowPlayingSong.display &&
                <MargedBlock>
                  <Label withPadding>{t('doYouWantToDisplaySongHistory')}</Label>
                  <RadioButtonGroup
                    name="doYouWantToDisplaySongHistory"
                    defaultSelected={data.recentlyPlayedSongs.display}
                    onChange={(e, v) => this.props.onValueChange('display', v)}
                  >
                    <RadioButton
                      value
                      label={t('yes')}
                    />
                    <RadioButton
                      value={false}
                      label={t('no')}
                    />
                  </RadioButtonGroup>
                </MargedBlock>
              }
              { this.shouldDisplay() &&
                <MargedBlock>
                  <Label>{t('maximumOfDisplayedSongInHistory')}</Label>
                  <TextField
                    value={data.recentlyPlayedSongs.maxSongs.toString()}
                    fullWidth
                    id={'title'}
                    onChange={(e, v) => this.onMaxSongsChange(v)}
                  />
                </MargedBlock>
              }
            </div>
          </div>
          <div className="col-xs-6">
            { this.shouldDisplay() &&
              <RecentlyPlayedSongsDemo
                colors={this.state}
                demoTheme={data.theme}
                name={data.stationInformation.name}
              />
            }
          </div>
        </div>
        { this.shouldDisplay() &&
          <MargedBlock className="row">
            <ColorPickerContainer className="col-xs-4 col-md-3">
              <Label withPadding>{t('backgroundColor')}</Label>
              <ChromePicker
                color={this.state.backgroundColor}
                onChange={color => this.onColorChange('backgroundColor', color)}
                onChangeComplete={color => this.onColorChangeComplete('backgroundColor', color)}
              />
            </ColorPickerContainer>
            <ColorPickerContainer className="col-xs-4 col-md-3">
              <Label withPadding>{t('mainTextColor')}</Label>
              <ChromePicker
                color={this.state.mainTextColor}
                onChange={color => this.onColorChange('mainTextColor', color)}
                onChangeComplete={color => this.onColorChangeComplete('mainTextColor', color)}
              />
            </ColorPickerContainer>
            <ColorPickerContainer className="col-xs-4 col-md-3">
              <Label withPadding>{t('secondaryTextColor')}</Label>
              <ChromePicker
                color={this.state.secondaryText}
                onChange={color => this.onColorChange('secondaryText', color)}
                onChangeComplete={color => this.onColorChangeComplete('secondaryText', color)}
              />
            </ColorPickerContainer>
          </MargedBlock>
        }
      </TitledCard>
    );
  }
}

export default withTheme(translate('radioConfiguration')(RecentlyPlayed));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/playerConfigurationForm/statsRadioPlayer/RecentlyPlayed.js